// File#: _1_filter
// Usage: codyhouse.co/license
(function() {
    var Filter = function(opts) {
      this.options = Util.extend(Filter.defaults , opts); // used to store custom filter/sort functions
      this.element = this.options.element;
      this.elementId = this.element.getAttribute('id');
      this.items = this.element.querySelectorAll('.js-filter__item');
      this.controllers = document.querySelectorAll('[aria-controls="'+this.elementId+'"]'); // controllers wrappers
      this.fallbackMessage = document.querySelector('[data-fallback-gallery-id="'+this.elementId+'"]');
      this.filterString = []; // combination of different filter values
      this.sortingString = '';  // sort value - will include order and type of argument (e.g., number or string)
      // store info about sorted/filtered items
      this.filterList = []; // list of boolean for each this.item -> true if still visible , otherwise false
      this.sortingList = []; // list of new ordered this.item -> each element is [item, originalIndex]
  
      // store grid info for animation
      this.itemsGrid = []; // grid coordinates
      this.itemsInitPosition = []; // used to store coordinates of this.items before animation
      this.itemsIterPosition = []; // used to store coordinates of this.items before animation - intermediate state
      this.itemsFinalPosition = []; // used to store coordinates of this.items after filtering
  
      // animation off
      this.animateOff = this.element.getAttribute('data-filter-animation') == 'off';
      // used to update this.itemsGrid on resize
      this.resizingId = false;
      // default acceleration style - improve animation
      this.accelerateStyle = 'will-change: transform, opacity; transform: translateZ(0); backface-visibility: hidden;';
  
      // handle multiple changes
      this.animating = false;
      this.reanimate = false;
      this.filterOperator = '';
     
      if (this.element.getAttribute('data-filter-operator')) {
        this.filterOperator = this.element.getAttribute('data-filter-operator');
      }
  
      initFilter(this);
    };
  
    function initFilter(filter) {
      resetFilterSortArray(filter, true, true); // init array filter.filterList/filter.sortingList
      createGridInfo(filter); // store grid coordinates in filter.itemsGrid
      initItemsOrder(filter); // add data-orders so that we can reset the sorting
  
      // events handling - filter update
      for(var i = 0; i < filter.controllers.length; i++) {
        filter.filterString[i] = ''; // reset filtering
  
        // get proper filter/sorting string based on selected controllers
        (function(i){
          filter.controllers[i].addEventListener('change', function(event) {
            if(event.target.tagName.toLowerCase() == 'select') { // select elements
              (!event.target.getAttribute('data-filter'))
                ? setSortingString(filter, event.target.value, event.target.options[event.target.selectedIndex])
                : setFilterString(filter, i, 'select');
            } else if(event.target.tagName.toLowerCase() == 'input' && (event.target.getAttribute('type') == 'radio' || event.target.getAttribute('type') == 'checkbox') ) { // input (radio/checkboxed) elements
              (!event.target.getAttribute('data-filter'))
                ? setSortingString(filter, event.target.getAttribute('data-sort'), event.target)
                : setFilterString(filter, i, 'input');
            } else {
              // generic inout element
              (!filter.controllers[i].getAttribute('data-filter'))
                ? setSortingString(filter, filter.controllers[i].getAttribute('data-sort'), filter.controllers[i])
                : setFilterString(filter, i, 'custom');
            }
  
            updateFilterArray(filter);
          });
  
          filter.controllers[i].addEventListener('click', function(event) { // retunr if target is select/input elements
            var filterEl = event.target.closest('[data-filter]');
            var sortEl = event.target.closest('[data-sort]');
            if(!filterEl && !sortEl) return;
            if(filterEl && ( filterEl.tagName.toLowerCase() == 'input' || filterEl.tagName.toLowerCase() == 'select')) return;
            if(sortEl && (sortEl.tagName.toLowerCase() == 'input' || sortEl.tagName.toLowerCase() == 'select')) return;
            if(sortEl && Util.hasClass(sortEl, 'js-filter__custom-control')) return;
            if(filterEl && Util.hasClass(filterEl, 'js-filter__custom-control')) return;
            // this will be executed only for a list of buttons -> no inputs
            event.preventDefault();
            resetControllersList(filter, i, filterEl, sortEl);
            sortEl
              ? setSortingString(filter, sortEl.getAttribute('data-sort'), sortEl)
              : setFilterString(filter, i, 'button');
            updateFilterArray(filter);
          });
  
          // target search inputs -> update them on 'input'
          filter.controllers[i].addEventListener('input', function(event) {
            if(event.target.tagName.toLowerCase() == 'input' && (event.target.getAttribute('type') == 'search' || event.target.getAttribute('type') == 'text') ) {
              setFilterString(filter, i, 'custom');
              updateFilterArray(filter);
            }
          });
        })(i);
      }
  
      // handle resize - update grid coordinates in filter.itemsGrid
      window.addEventListener('resize', function() {
        clearTimeout(filter.resizingId);
        filter.resizingId = setTimeout(function(){createGridInfo(filter)}, 300);
      });
  
      // check if there are filters/sorting values already set
      checkInitialFiltering(filter);
  
      // reset filtering results if filter selection was changed by an external control (e.g., form reset)
      filter.element.addEventListener('update-filter-results', function(event){
        // reset filters first
        for(var i = 0; i < filter.controllers.length; i++) filter.filterString[i] = '';
        filter.sortingString = '';
        checkInitialFiltering(filter);
      });
    };
  
    function checkInitialFiltering(filter) {
      for(var i = 0; i < filter.controllers.length; i++) { // check if there's a selected option
        // buttons list
        var selectedButton = filter.controllers[i].getElementsByClassName('js-filter-selected');
        if(selectedButton.length > 0) {
          var sort = selectedButton[0].getAttribute('data-sort');
          sort
            ? setSortingString(filter, selectedButton[0].getAttribute('data-sort'), selectedButton[0])
            : setFilterString(filter, i, 'button');
          continue;
        }
  
        // input list
        var selectedInput = filter.controllers[i].querySelectorAll('input:checked');
        if(selectedInput.length > 0) {
          var sort = selectedInput[0].getAttribute('data-sort');
          sort
            ? setSortingString(filter, sort, selectedInput[0])
            : setFilterString(filter, i, 'input');
          continue;
        }
        // select item
        if(filter.controllers[i].tagName.toLowerCase() == 'select') {
          var sort = filter.controllers[i].getAttribute('data-sort');
          sort
            ? setSortingString(filter, filter.controllers[i].value, filter.controllers[i].options[filter.controllers[i].selectedIndex])
            : setFilterString(filter, i, 'select');
           continue;
        }
        // check if there's a generic custom input
        var radioInput = filter.controllers[i].querySelector('input[type="radio"]'),
          checkboxInput = filter.controllers[i].querySelector('input[type="checkbox"]');
        if(!radioInput && !checkboxInput) {
          var sort = filter.controllers[i].getAttribute('data-sort');
          var filterString = filter.controllers[i].getAttribute('data-filter');
          if(sort) setSortingString(filter, sort, filter.controllers[i]);
          else if(filterString) setFilterString(filter, i, 'custom');
        }
      }
  
      updateFilterArray(filter);
    };
  
    function setSortingString(filter, value, item) {
      // get sorting string value-> sortName:order:type
      var order = item.getAttribute('data-sort-order') ? 'desc' : 'asc';
      var type = item.getAttribute('data-sort-number') ? 'number' : 'string';
      filter.sortingString = value+':'+order+':'+type;
    };
  
    function setFilterString(filter, index, type) {
      // console.log(filter, index, type);
      // get filtering array -> [filter1:filter2, filter3, filter4:filter5]
      if(type == 'input') {
        var checkedInputs = filter.controllers[index].querySelectorAll('input:checked');
        filter.filterString[index] = '';
        for(var i = 0; i < checkedInputs.length; i++) {
          filter.filterString[index] = filter.filterString[index] + checkedInputs[i].getAttribute('data-filter') + ':';
        }
      } else if(type == 'select') {
        if(filter.controllers[index].multiple) { // select with multiple options
          filter.filterString[index] = getMultipleSelectValues(filter.controllers[index]);
        } else { // select with single option
          filter.filterString[index] = filter.controllers[index].value;
        }
      } else if(type == 'button') {
        var selectedButtons = filter.controllers[index].querySelectorAll('.js-filter-selected');
        filter.filterString[index] = '';
        for(var i = 0; i < selectedButtons.length; i++) {
          filter.filterString[index] = filter.filterString[index] + selectedButtons[i].getAttribute('data-filter') + ':';
        }
      } else if(type == 'custom') {
        filter.filterString[index] = filter.controllers[index].getAttribute('data-filter');
      }
    };
  
    function resetControllersList(filter, index, target1, target2) {
      // for a <button>s list -> toggle js-filter-selected + custom classes
      var multi = filter.controllers[index].getAttribute('data-filter-checkbox'),
        customClass = filter.controllers[index].getAttribute('data-selected-class');
  
      customClass = (customClass) ? 'js-filter-selected '+ customClass : 'js-filter-selected';
      if(multi == 'true') { // multiple options can be on
        (target1)
          ? Util.toggleClass(target1, customClass, !Util.hasClass(target1, 'js-filter-selected'))
          : Util.toggleClass(target2, customClass, !Util.hasClass(target2, 'js-filter-selected'));
      } else { // only one element at the time
        // remove the class from all siblings
        var selectedOption = filter.controllers[index].querySelector('.js-filter-selected');
        if(selectedOption) Util.removeClass(selectedOption, customClass);
        (target1)
          ? Util.addClass(target1, customClass)
          : Util.addClass(target2, customClass);
      }
    };
  
    function updateFilterArray(filter) { // sort/filter strings have been updated -> so you can update the gallery
      if(filter.animating) {
        filter.reanimate = true;
        return;
      }
      filter.animating = true;
      filter.reanimate = false;
      createGridInfo(filter); // get new grid coordinates
      sortingGallery(filter); // update sorting list
      filteringGallery(filter); // update filter list
      resetFallbackMessage(filter, true); // toggle fallback message
      if(reducedMotion || filter.animateOff) {
        resetItems(filter);
      } else {
        updateItemsAttributes(filter);
      }
    };
  
    function sortingGallery(filter) {
      // use sorting string to reorder gallery
      var sortOptions = filter.sortingString.split(':');
      if(sortOptions[0] == '' || sortOptions[0] == '*') {
        // no sorting needed
        restoreSortOrder(filter);
      } else { // need to sort
        if(filter.options[sortOptions[0]]) { // custom sort function -> user takes care of it
          filter.sortingList = filter.options[sortOptions[0]](filter.sortingList);
        } else {
          filter.sortingList.sort(function(left, right) {
            var leftVal = left[0].getAttribute('data-sort-'+sortOptions[0]),
            rightVal = right[0].getAttribute('data-sort-'+sortOptions[0]);
            if(sortOptions[2] == 'number') {
              leftVal = parseFloat(leftVal);
              rightVal = parseFloat(rightVal);
            }
            if(sortOptions[1] == 'desc') return leftVal <= rightVal ? 1 : -1;
            else return leftVal >= rightVal ? 1 : -1;
          });
        }
      }
    };
  
    function filteringGallery(filter) {
      // use filtering string to reorder gallery
      resetFilterSortArray(filter, true, false);
      // we can have multiple filters
      for(var i = 0; i < filter.filterString.length; i++) {
        //check if multiple filters inside the same controller
        if(filter.filterString[i] != '' && filter.filterString[i] != '*' && filter.filterString[i] != ' ') {
          singleFilterGallery(filter, filter.filterString[i].split(':'));
        }
      }
    };
  
    function singleFilterGallery(filter, subfilter) {
      if(!subfilter || subfilter == '' || subfilter == '*') return;
      
      // check if we have custom options
      var customFilterArray = [];
      for(var j = 0; j < subfilter.length; j++) {
        if(filter.options[subfilter[j]]) { // custom function
          customFilterArray[subfilter[j]] = filter.options[subfilter[j]](filter.items);
        }
      }
      // console.log(subfilter);
      for(var i = 0; i < filter.items.length; i++) {
        var filterValues = filter.items[i].getAttribute('data-filter').split(' ');
        var present = false;
        // check for data-filter-operator and if === and disregard default "or" search
        if (filter.filterOperator === 'and') { 
          if (subfilter.slice(0,-1).every(item => filterValues.includes(item))) { // trim the last filter, which should be an empty string and apply the filters
            present = true;
          }
        } else {
          for(var j = 0; j < subfilter.length; j++) {
            // console.log(filter.options[subfilter[j]], customFilterArray[subfilter[j]][i]);
            if(filter.options[subfilter[j]] && customFilterArray[subfilter[j]][i]) { // custom function
              present = true;
              break;
            } else if(subfilter[j] == '*' || filterValues.indexOf(subfilter[j]) > -1) {
              present = true;
              break;
            }
          }
        }
        filter.filterList[i] = !present ? false : filter.filterList[i];
      }
    };
  
    function updateItemsAttributes(filter) { // set items before triggering the update animation
      // get offset of all elements before animation
      storeOffset(filter, filter.itemsInitPosition);
      // set height of container
      filter.element.setAttribute('style', 'height: '+parseFloat(filter.element.offsetHeight)+'px; width: '+parseFloat(filter.element.offsetWidth)+'px;');
  
      for(var i = 0; i < filter.items.length; i++) { // remove is-hidden class from items now visible and scale to zero
        if( Util.hasClass(filter.items[i], 'is-hidden') && filter.filterList[i]) {
          filter.items[i].setAttribute('data-scale', 'on');
          filter.items[i].setAttribute('style', filter.accelerateStyle+'transform: scale(0.5); opacity: 0;')
          Util.removeClass(filter.items[i], 'is-hidden');
        }
      }
      // get new elements offset
      storeOffset(filter, filter.itemsIterPosition);
      // translate items so that they are in the right initial position
      for(var i = 0; i < filter.items.length; i++) {
        if( filter.items[i].getAttribute('data-scale') != 'on') {
          filter.items[i].setAttribute('style', filter.accelerateStyle+'transform: translateX('+parseInt(filter.itemsInitPosition[i][0] - filter.itemsIterPosition[i][0])+'px) translateY('+parseInt(filter.itemsInitPosition[i][1] - filter.itemsIterPosition[i][1])+'px);');
        }
      }
  
      animateItems(filter)
    };
  
    function animateItems(filter) {
      var transitionValue = 'transform '+filter.options.duration+'ms cubic-bezier(0.455, 0.03, 0.515, 0.955), opacity '+filter.options.duration+'ms';
  
      // get new index of items in the list
      var j = 0;
      for(var i = 0; i < filter.sortingList.length; i++) {
        var item = filter.items[filter.sortingList[i][1]];
  
        if(Util.hasClass(item, 'is-hidden') || !filter.filterList[filter.sortingList[i][1]]) {
          // item is hidden or was previously hidden -> final position equal to first one
          filter.itemsFinalPosition[filter.sortingList[i][1]] = filter.itemsIterPosition[filter.sortingList[i][1]];
          if(item.getAttribute('data-scale') == 'on') j = j + 1;
        } else {
          filter.itemsFinalPosition[filter.sortingList[i][1]] = [filter.itemsGrid[j][0], filter.itemsGrid[j][1]]; // left/top
          j = j + 1;
        }
      }
  
      setTimeout(function(){
        for(var i = 0; i < filter.items.length; i++) {
          if(filter.filterList[i] && filter.items[i].getAttribute('data-scale') == 'on') { // scale up item
            filter.items[i].setAttribute('style', filter.accelerateStyle+'transition: '+transitionValue+'; transform: translateX('+parseInt(filter.itemsFinalPosition[i][0] - filter.itemsIterPosition[i][0])+'px) translateY('+parseInt(filter.itemsFinalPosition[i][1] - filter.itemsIterPosition[i][1])+'px) scale(1); opacity: 1;');
          } else if(filter.filterList[i]) { // translate item
            filter.items[i].setAttribute('style', filter.accelerateStyle+'transition: '+transitionValue+'; transform: translateX('+parseInt(filter.itemsFinalPosition[i][0] - filter.itemsIterPosition[i][0])+'px) translateY('+parseInt(filter.itemsFinalPosition[i][1] - filter.itemsIterPosition[i][1])+'px);');
          } else { // scale down item
            filter.items[i].setAttribute('style', filter.accelerateStyle+'transition: '+transitionValue+'; transform: scale(0.5); opacity: 0;');
          }
        };
      }, 50);
  
      // wait for the end of transition of visible elements
      setTimeout(function(){
        resetItems(filter);
      }, (filter.options.duration + 100));
    };
  
    function resetItems(filter) {
      // animation was off or animation is over -> reset attributes
      for(var i = 0; i < filter.items.length; i++) {
        filter.items[i].removeAttribute('style');
        Util.toggleClass(filter.items[i], 'is-hidden', !filter.filterList[i]);
        filter.items[i].removeAttribute('data-scale');
      }
  
      for(var i = 0; i < filter.items.length; i++) {// reorder
        filter.element.appendChild(filter.items[filter.sortingList[i][1]]);
      }
  
      filter.items = [];
      filter.items = filter.element.querySelectorAll('.js-filter__item');
      resetFilterSortArray(filter, false, true);
      filter.element.removeAttribute('style');
      filter.animating = false;
      if(filter.reanimate) {
        updateFilterArray(filter);
      }
  
      resetFallbackMessage(filter, false); // toggle fallback message
  
      // emit custom event - end of filtering
      filter.element.dispatchEvent(new CustomEvent('filter-selection-updated'));
    };
  
    function resetFilterSortArray(filter, filtering, sorting) {
      for(var i = 0; i < filter.items.length; i++) {
        if(filtering) filter.filterList[i] = true;
        if(sorting) filter.sortingList[i] = [filter.items[i], i];
      }
    };
  
    function createGridInfo(filter) {
      var containerWidth = parseFloat(window.getComputedStyle(filter.element).getPropertyValue('width')),
        itemStyle, itemWidth, itemHeight, marginX, marginY, colNumber;
  
      // get offset first visible element
      for(var i = 0; i < filter.items.length; i++) {
        if( !Util.hasClass(filter.items[i], 'is-hidden') ) {
          itemStyle = window.getComputedStyle(filter.items[i]),
          itemWidth = parseFloat(itemStyle.getPropertyValue('width')),
          itemHeight = parseFloat(itemStyle.getPropertyValue('height')),
          marginX = parseFloat(itemStyle.getPropertyValue('margin-left')) + parseFloat(itemStyle.getPropertyValue('margin-right')),
          marginY = parseFloat(itemStyle.getPropertyValue('margin-bottom')) + parseFloat(itemStyle.getPropertyValue('margin-top')),
          colNumber = parseInt((containerWidth + marginX)/(itemWidth+marginX));
          filter.itemsGrid[0] = [filter.items[i].offsetLeft, filter.items[i].offsetTop]; // left, top
          break;
        }
      }
  
      for(var i = 1; i < filter.items.length; i++) {
        var x = i < colNumber ? i : i % colNumber,
          y = i < colNumber ? 0 : Math.floor(i/colNumber);
        filter.itemsGrid[i] = [filter.itemsGrid[0][0] + x*(itemWidth+marginX), filter.itemsGrid[0][1] + y*(itemHeight+marginY)];
      }
    };
  
    function storeOffset(filter, array) {
      for(var i = 0; i < filter.items.length; i++) {
        array[i] = [filter.items[i].offsetLeft, filter.items[i].offsetTop];
      }
    };
  
    function initItemsOrder(filter) {
      for(var i = 0; i < filter.items.length; i++) {
        filter.items[i].setAttribute('data-init-sort-order', i);
      }
    };
  
    function restoreSortOrder(filter) {
      for(var i = 0; i < filter.items.length; i++) {
        filter.sortingList[parseInt(filter.items[i].getAttribute('data-init-sort-order'))] = [filter.items[i], i];
      }
    };
  
    function resetFallbackMessage(filter, bool) {
      if(!filter.fallbackMessage) return;
      var show = true;
      for(var i = 0; i < filter.filterList.length; i++) {
        if(filter.filterList[i]) {
          show = false;
          break;
        }
      };
      if(bool) { // reset visibility before animation is triggered
        if(!show) Util.addClass(filter.fallbackMessage, 'is-hidden');
        return;
      }
      Util.toggleClass(filter.fallbackMessage, 'is-hidden', !show);
    };
  
    function getMultipleSelectValues(multipleSelect) {
      // get selected options of a <select multiple> element
      var options = multipleSelect.options,
        value = '';
      for(var i = 0; i < options.length; i++) {
        if(options[i].selected) {
          if(value != '') value = value + ':';
          value = value + options[i].value;
        }
      }
      return value;
    };
  
    Filter.defaults = {
      element : false,
      duration: 400
    };
  
    window.Filter = Filter;
  
    // init Filter object
    var filterGallery = document.getElementsByClassName('js-filter'),
      reducedMotion = Util.osHasReducedMotion();
    if( filterGallery.length > 0 ) {
      for( var i = 0; i < filterGallery.length; i++) {
        var duration = filterGallery[i].getAttribute('data-filter-duration');
        if(!duration) duration = Filter.defaults.duration;
        new Filter({element: filterGallery[i], duration: duration});
      }
    }
  }());
  